import { EditorState, SelectionState } from "draft-js";

/**
 * @param   {EditorState}  editorState
 * @param   {ContentBlock} block
 * @returns {EditorState}
 */
export default function removeBlockByKey(editorState, block) {
  const selection = editorState.getSelection();
  const content = editorState.getCurrentContent();
  const keyAfter = content.getKeyAfter(block.getKey());
  const blockMap = content.getBlockMap().delete(block.getKey());

  // const emptyUnstyledBlock = new ContentBlock({
  //   key: genKey(),
  //   type: "unstyled",
  //   text: "",
  //   characterList: List(),
  // });

  const withoutAtomicBlock = content.merge({
    blockMap: blockMap,
    selectionAfter: selection,
  });

  const newState = EditorState.push(editorState, withoutAtomicBlock, "remove-range");

  // If this is not the last block
  if (keyAfter) {
    const newSelection = new SelectionState({
      anchorKey: keyAfter,
      anchorOffset: 0,
      focusKey: keyAfter,
      focusOffset: block.getLength(),
    });

    return EditorState.forceSelection(newState, newSelection);
  }

  return newState;
}
